// Official hostname registered with Centro:
export const hostName = 'MicrosoftDefender';

// used in IFeedbackInitOptions for OCV initialization:
export const clientName = 'Microsoft Consumer Security Portal';

// used in IFeedbackInitOptions for OCV initialization, depending on the environment:
export const appIds = {
  prod: 2479,
  int: 50047,
};
